
import DataMapper from '../DataMapper'
import HospitalInfraInvestigatorRM from '../../responsemodel/ReportRM/HospitalInfraInvestigatorRM'
import HospitalInfraInvestigatorList from '../../../models/ReportModels/HospitalInfraInvestigatorList'

export default class HospitalInfraInvestigatorDataMapper extends DataMapper<HospitalInfraInvestigatorRM, HospitalInfraInvestigatorList> {
    map = (rm: HospitalInfraInvestigatorRM) => new HospitalInfraInvestigatorList(rm._id, rm.claim_number, rm.modified_on, rm.name)
}
